import { render } from "./ElNavigationTrigger.vue?vue&type=template&id=2db72956&scoped=true&lang=html"
import script from "./ElNavigationTrigger.vue?vue&type=script&lang=js"
export * from "./ElNavigationTrigger.vue?vue&type=script&lang=js"

import "./ElNavigationTrigger.vue?vue&type=style&index=0&id=2db72956&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db72956"]])

export default __exports__